import {
  addSeconds,
  differenceInDays,
  differenceInSeconds,
  endOfISOWeek,
  intervalToDuration,
  subHours
} from "date-fns";

import { formatWithLeadingZero } from "seneca-common/utils/functions/format";

import { useCountdown } from "./useCountdown";

export default function useCountdownToDate({
  endTime,
  now = new Date()
}: {
  endTime: Date | string;
  now?: Date;
}) {
  const endDate = endTime instanceof Date ? endTime : new Date(endTime);

  const secondsUntilEndDate = differenceInSeconds(endDate, now);

  const { count, ...countdown } = useCountdown<
    ReturnType<typeof formatSecondsToDHMS>
  >({
    countStart: secondsUntilEndDate,
    formatter: count => formatSecondsToDHMS(now, count)
  });

  return { ...count, countdown };
}

function formatSecondsToDHMS(now: Date, totalSeconds: number) {
  const end = addSeconds(now, totalSeconds);

  const { hours, minutes, seconds } = intervalToDuration({
    start: now,
    end
  });

  const days = differenceInDays(end, now);

  return {
    days: formatWithLeadingZero(days),
    hours: formatWithLeadingZero(hours!),
    minutes: formatWithLeadingZero(minutes!),
    seconds: formatWithLeadingZero(seconds!)
  };
}

export const DEFAULT_LEADERBOARD_END_DATE = subHours(
  endOfISOWeek(new Date()),
  3
).toISOString();
